import * as React from 'react';
import { 
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { getTemplate } from '../slices/utils';

import axios from 'axios';

import { API_URI } from '../const';

export default function PptModal(props) {
  const {open, data, handleClose} = props;
  const [dataType, setDataType] = React.useState(1);
  const [commentary, setCommentary] = React.useState(false);

  const templates = useSelector(state => state.utils.templates)
  const dispatch = useDispatch();
  
  const [template, setTemplate] = React.useState("default");
  const [loading, setLoading] = React.useState(false);

  // Fetch templates when component mounts
  React.useEffect(() => {
    if (open && templates.length === 0) {
      dispatch(getTemplate());
    }
  }, [open, templates.length, dispatch]);
  
  const unit = sessionStorage.getItem("numberUnit") || 3;
  const separator = sessionStorage.getItem("numberSeparator") || ",";
  const decimalPlace = sessionStorage.getItem("decimalPlace") || 2;

  const handleOk = (e) => {
    const databaseString = sessionStorage.getItem("dbName");

    const defaultDatabase = databaseString === null ? "northwind.db": databaseString;
    const token = localStorage.getItem("token"); 


    const config = {
      method: 'post',
      url: `${API_URI}v1/user/presentation/generateoneppt`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        template, 
        data, 
        commentary,
        database_path: defaultDatabase, 
        data_type: dataType,
        separator,
        unit,
        decimal_place: decimalPlace
      })
    };

    setLoading(true);
    axios.request(config)
      .then(response => {
        return response.data;
      })
      .then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'test.pptx';
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element  
        setLoading(false);
        handleClose();
      })
      .catch(err => {
        console.log(err);
        window.alert("I can't generate the powerpoint for the prompts");
        setLoading(false);
      })
  }

  const handleChangeDataType = (e) => {
    setDataType(e.target.value);
  }

  const handleChangeCommentary = (e) => {
    setCommentary(e.target.checked);
  }

  const handleChangeTemplate = (e) => {
    setTemplate(e.target.value);
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth
      >
        <DialogTitle>PowerPoint Setting</DialogTitle>
        <DialogContent>
          <FormControl sx={{mt: 1}} fullWidth>
            <InputLabel id="demo-simple-select-label">Template</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="template-select"
              value={template}
              label="Template"
              onChange={handleChangeTemplate}
              fullWidth={true}
              >
                {
                  templates && templates.length>0 && templates.map(item=> (<MenuItem key={item} value={item}>{item}</MenuItem>))
                }
            </Select>
          </FormControl>
          <FormControl sx={{mt: 2}} fullWidth>
            <InputLabel id={`demo-simple-select-label-${1}`} >Data Type</InputLabel>
            <Select
              labelId={`demo-simple-select-label-${1}`}
              id="data-type-select"
              value={dataType}
              label="DataType"
              onChange={handleChangeDataType}
              fullWidth
              >
              <MenuItem value={1}>Data</MenuItem>
              <MenuItem value={2}>Visualization </MenuItem>
              <MenuItem value={3}>Data & Visualization</MenuItem>
            </Select>
          </FormControl>
          <FormGroup sx={{mt: 1}}>
            <FormControlLabel required control={<Checkbox checked={commentary} onChange={handleChangeCommentary} />} label="Generate Commentary" />
          </FormGroup>
          <Box className="w-full h-full flex justify-center align-center">
            {loading && (<CircularProgress/>)}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleOk} disabled={loading}>Generate</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}